import MenuItem from "./sidebar/menu-item";

export interface InternetMenuItemsProps {
  onShow: (isVisible: boolean) => void;
  onCollapse: (isCollapsed: boolean) => void;
}
export default function InternetMenuItems({
  onShow,
  onCollapse,
}: InternetMenuItemsProps) {
  return (
    <MenuItem
      title="تست سرعت"
      to="/speedTest/result"
      icon="space-shuttle"
      iconBgc="yellow-tp1"
      fadeable
      onShow={() => onShow(false)}
      onCollapse={() => onCollapse(true)}
    />
  );
}
